
let GetExcelHelper = function () {

    function _ExportarExcel(nombreArchivo, Fila) {

        var csv = '';
        var row;
        var val;
        var encabezado;

        if (Fila != null && Fila.length > 0) {
            encabezado = Object.getOwnPropertyNames(Fila[0]);
            for (var z = 0; z < encabezado.length; z++) {
                if (encabezado[z] != null)
                    val = encabezado[z].toString();
                else
                    val = " ";
                if (z > 0)
                    csv += '\t';
                csv += val;
            }

            csv += '\n';

            for (var i = 0; i < Fila.length; i++) {
                row = Object.values(Fila[i]);
                for (var j = 0; j < row.length; j++) {
                    if (row[j] != null)
                        val = row[j].toString();
                    else
                        val = " ";

                    if (j > 0)
                        csv += '\t';
                    csv += val;
                }
                csv += '\n';
            }

            // Para archivo tipo UTF-16
            var code, blobArray = [];
            blobArray.push(255, 254);
            for (var i = 0; i < csv.length; ++i) {
                code = csv.charCodeAt(i);
                blobArray.push(code & 0xff);
                blobArray.push(code / 256 >>> 0);
            }

            var blob = new Blob([new Uint8Array(blobArray)], { type: 'text/csv;charset=UTF-16LE;' });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, nombreArchivo);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    var url = window.URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", nombreArchivo);
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                }
            }
        }
    }

    return {
        ExportarExcel: function (numeroDocumentoAconvertir, tipoDocumento) {
            return _ExportarExcel(numeroDocumentoAconvertir, tipoDocumento);
        }
    }
    
}

let getExcelHelper = new GetExcelHelper();
export default getExcelHelper;

